<template>
  <div>
    <virtual-auto-log-list />
  </div>
</template>
<script>
import virtualAutoLogList from './list.vue'

export default {
  name: 'VirtualAutoLog',
  components: {
    virtualAutoLogList
  }
}
</script>
